import React from 'react';
import ContactUI from '../core-ui/contacts/contacts-ui';

const Contacts = () => <ContactUI />;

export default Contacts;
